// extracted by mini-css-extract-plugin
module.exports = {"root":"MessageEditor_root__1I2xr"};